//@ts-nocheck
import React, { useState, useEffect, useRef } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import InputMask from 'react-input-mask';
import {
  TextField,
  MenuItem,
  Box,
  OutlinedInputProps,
  Select,
  FormControl,
  createStyles,
  makeStyles,
  Theme,
} from '@material-ui/core';

import { FieldProps } from '../../types';
import { appTextFieldRootStyle } from '../inputs';
import { getBackground } from '../../theme/styles';

export const countries = [
  { code: 'gb', flag: '🇬🇧', name: 'United Kingdom', dialCode: '+44', mask: '+44 9999 999999' },
  { code: 'lv', flag: '🇱🇻', name: 'Latvia', dialCode: '+371', mask: '+371 99 999 999' },
  { code: 'pl', flag: '🇵🇱', name: 'Poland', dialCode: '+48', mask: '+48 999 999 999' },
  { code: 'lt', flag: '🇱🇹', name: 'Lithuania', dialCode: '+370', mask: '+370 999 99 999' },
  { code: 'ro', flag: '🇷🇴', name: 'Romania', dialCode: '+40', mask: '+40 999 999 9999' },
  { code: 'rs', flag: '🇷🇸', name: 'Serbia', dialCode: '+381', mask: '+381 99 9999999' },
  { code: 'sk', flag: '🇸🇰', name: 'Slovakia', dialCode: '+421', mask: '+421 999 999999' },
  { code: 'si', flag: '🇸🇮', name: 'Slovenia', dialCode: '+386', mask: '+386 99 999999' },
  { code: 'hr', flag: '🇭🇷', name: 'Croatia', dialCode: '+385', mask: '+385 99 999 9999' },
  { code: 'de', flag: '🇩🇪', name: 'Germany', dialCode: '+49', mask: '+49 9999 9999999' },
  { code: 'al', flag: '🇦🇱', name: 'Albania', dialCode: '+355', mask: '+355 99 999 9999' },
  { code: 'ad', flag: '🇦🇩', name: 'Andorra', dialCode: '+376', mask: '+376 999 999' },
  { code: 'at', flag: '🇦🇹', name: 'Austria', dialCode: '+43', mask: '+43 999 9999999' },
  { code: 'by', flag: '🇧🇾', name: 'Belarus', dialCode: '+375', mask: '+375 99 999 99 99' },
  { code: 'be', flag: '🇧🇪', name: 'Belgium', dialCode: '+32', mask: '+32 999 99 99 99' },
  { code: 'ba', flag: '🇧🇦', name: 'Bosnia and Herzegovina', dialCode: '+387', mask: '+387 99 999999' },
  { code: 'bg', flag: '🇧🇬', name: 'Bulgaria', dialCode: '+359', mask: '+359 999 999999' },
  { code: 'cy', flag: '🇨🇾', name: 'Cyprus', dialCode: '+357', mask: '+357 99 999999' },
  { code: 'cz', flag: '🇨🇿', name: 'Czech Republic', dialCode: '+420', mask: '+420 999 999 999' },
  { code: 'dk', flag: '🇩🇰', name: 'Denmark', dialCode: '+45', mask: '+45 99 99 99 99' },
  { code: 'ee', flag: '🇪🇪', name: 'Estonia', dialCode: '+372', mask: '+372 9999 9999' },
  { code: 'fo', flag: '🇫🇴', name: 'Faroe Islands', dialCode: '+298', mask: '+298 999999' },
  { code: 'fi', flag: '🇫🇮', name: 'Finland', dialCode: '+358', mask: '+358 999 9999999' },
  { code: 'fr', flag: '🇫🇷', name: 'France', dialCode: '+33', mask: '+33 9 99 99 99 99' },
  { code: 'gi', flag: '🇬🇮', name: 'Gibraltar', dialCode: '+350', mask: '+350 99999999' },
  { code: 'gr', flag: '🇬🇷', name: 'Greece', dialCode: '+30', mask: '+30 999 999 9999' },
  { code: 'hu', flag: '🇭🇺', name: 'Hungary', dialCode: '+36', mask: '+36 99 999 9999' },
  { code: 'is', flag: '🇮🇸', name: 'Iceland', dialCode: '+354', mask: '+354 999 9999' },
  { code: 'ie', flag: '🇮🇪', name: 'Ireland', dialCode: '+353', mask: '+353 99 999 9999' },
  { code: 'it', flag: '🇮🇹', name: 'Italy', dialCode: '+39', mask: '+39 999 999 9999' },
  { code: 'li', flag: '🇱🇮', name: 'Liechtenstein', dialCode: '+423', mask: '+423 999 9999' },
  { code: 'lu', flag: '🇱🇺', name: 'Luxembourg', dialCode: '+352', mask: '+352 999 999 999' },
  { code: 'mk', flag: '🇲🇰', name: 'North Macedonia', dialCode: '+389', mask: '+389 99 999 999' },
  { code: 'mt', flag: '🇲🇹', name: 'Malta', dialCode: '+356', mask: '+356 9999 9999' },
  { code: 'md', flag: '🇲🇩', name: 'Moldova', dialCode: '+373', mask: '+373 9999 9999' },
  { code: 'mc', flag: '🇲🇨', name: 'Monaco', dialCode: '+377', mask: '+377 99 999 999' },
  { code: 'me', flag: '🇲🇪', name: 'Montenegro', dialCode: '+382', mask: '+382 99 999999' },
  { code: 'nl', flag: '🇳🇱', name: 'Netherlands', dialCode: '+31', mask: '+31 99 999 9999' },
  { code: 'no', flag: '🇳🇴', name: 'Norway', dialCode: '+47', mask: '+47 999 99 999' },
  { code: 'pt', flag: '🇵🇹', name: 'Portugal', dialCode: '+351', mask: '+351 999 999 999' },
  { code: 'ru', flag: '🇷🇺', name: 'Russia', dialCode: '+7', mask: '+7 999 999 99 99' },
  { code: 'sm', flag: '🇸🇲', name: 'San Marino', dialCode: '+378', mask: '+378 999999999' },
  { code: 'es', flag: '🇪🇸', name: 'Spain', dialCode: '+34', mask: '+34 999 999 999' },
  { code: 'se', flag: '🇸🇪', name: 'Sweden', dialCode: '+46', mask: '+46 999 999 9999' },
  { code: 'ch', flag: '🇨🇭', name: 'Switzerland', dialCode: '+41', mask: '+41 99 999 99 99' },
  { code: 'tr', flag: '🇹🇷', name: 'Turkey', dialCode: '+90', mask: '+90 999 999 99 99' },
  { code: 'ua', flag: '🇺🇦', name: 'Ukraine', dialCode: '+380', mask: '+380 99 999 9999' },
  { code: 'va', flag: '🇻🇦', name: 'Vatican City', dialCode: '+379', mask: '+379 999999999' },
  { code: 'us', flag: '🇺🇸', name: 'United States', dialCode: '+1', mask: '+1 (999) 999-9999' },
  { code: 'am', flag: '🇦🇲', name: 'Armenia', dialCode: '+374', mask: '+374 99 999999' },
];

export const validatePhone = (value: string = '') => {
  const cleaned = value.replace(/[^\d+]/g, '');
  if (cleaned.includes('+44') && cleaned[3] === '0') {
    return 'Please remove the first 0';
  }
  return !cleaned.length || cleaned.length > 8 || 'Invalid Mobile Number';
};

const detectCountryByNumber = (phone: string, countries: typeof countries) => {
  if (!phone) return null;
  return countries.find(c => phone.startsWith(c.dialCode)) || null;
};

export const mobileNumberRules = {
  required: 'Phone Number is required',
};

const useLabelStyles = makeStyles(() => ({
  label: {
    left: '-4px !important',
  },
}));

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: { ...appTextFieldRootStyle(theme), borderTopLeftRadius: 0, borderBottomLeftRadius: 0 },
    input: {
      padding: '27px 5px 10px',
    },
    focused: {},
  })
);

const useSelectorStyles = makeStyles((theme: Theme) =>
  createStyles({
    inputRoot: {
      width: '41px',
      minWidth: 41,
      overflow: 'hidden',
      borderTopLeftRadius: 16,
      borderBottomLeftRadius: 16,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,

      '& .MuiSelect-icon': {
        display: 'none',
      },
      '&:before, &:after': { borderBottom: 'none' },

      '& .MuiSelect-filled': {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 16,
        paddingLeft: 12,
        paddingRight: '12px !important',
        backgroundColor: getBackground(theme.palette.type === 'dark').backgroundInput,
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:hover, &$focused': {
          backgroundColor: theme.palette.background.paper,
          borderColor: theme.palette.primary.main,
        },
      },
    },
  })
);

export const PhoneNumberFieldV2: React.FC<FieldProps> = ({
  margin,
  label = 'Phone Number',
  name = '',
  rules = mobileNumberRules,
  autoFocus = false,
  disabled = false,
  onKeyDown,
}) => {
  const { control } = useFormContext();
  const { field, fieldState } = useController({
    control,
    name,
    rules: { ...rules, validate: validatePhone },
  });
  const classes = useStyles();
  const labelClasses = useLabelStyles();
  const selectClasses = useSelectorStyles();
  const inputRef = useRef<HTMLInputElement>(null);

  const cleanedValue = field.value || '';

  const [country, setCountry] = useState(countries[0]);
  const [maskedValue, setMaskedValue] = useState<string>(cleanedValue);

  const stripMasked = (v: string = '') => v.replace(/[^\d+]/g, '');

  const handleCountryChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const newCountry = countries.find(c => c.code === event.target.value);
    if (!newCountry) return;
    setCountry(newCountry);

    const digits = (cleanedValue || '').replace(/\D/g, '');
    const digitsInMask = (newCountry.mask.match(/9/g) || []).length;
    const digitsWithoutCode = digits.replace(new RegExp('^' + newCountry.dialCode.replace(/\D/g, '')), '');

    const trimmedDigits = digitsWithoutCode.slice(0, digitsInMask);

    const cleanedNext = newCountry.dialCode + trimmedDigits;
    field.onChange(cleanedNext);
    setMaskedValue(cleanedNext);

    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };

  useEffect(() => {
    // Keep the UI value in sync with the stored (cleaned) value,
    // but don't fight the mask while typing: only resync when the cleaned values diverge.
    const cleanedFormValue = stripMasked(cleanedValue || '');
    const cleanedMaskedValue = stripMasked(maskedValue || '');
    if (cleanedFormValue !== cleanedMaskedValue) {
      setMaskedValue(cleanedValue || '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cleanedValue]);

  useEffect(() => {
    if (!cleanedValue) return;
    const detected = detectCountryByNumber(cleanedValue, countries);
    if (detected) {
      setCountry(prev => (detected.code !== prev.code ? detected : prev));
    }
  }, [cleanedValue]);

  return (
    <Box display="flex" width="100%">
      <FormControl variant="filled" margin={margin}>
        <Select
          disabled={disabled}
          value={country.code}
          onChange={handleCountryChange}
          variant="filled"
          className={selectClasses.inputRoot}
          disableUnderline
          renderValue={value => {
            const c = countries.find(x => x.code === value);
            return c ? c.flag : '';
          }}>
          {countries.map(c => (
            <MenuItem key={c.code} value={c.code}>
              <Box display="flex" gridGap={4}>
                <span>{c.flag}</span>
                <span>{c.name}</span>
                <span>{c.dialCode}</span>
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <InputMask
        mask={country.mask}
        value={maskedValue}
        disabled={disabled}
        onChange={e => {
          const nextMasked = e.target.value;
          setMaskedValue(nextMasked);
          field.onChange(stripMasked(nextMasked));
        }}>
        {(inputProps: any) => (
          <TextField
            {...inputProps}
            variant="filled"
            label={label}
            inputRef={inputRef}
            error={!!fieldState.error?.message}
            helperText={fieldState.error?.message || ''}
            fullWidth
            autoFocus={autoFocus}
            margin={margin}
            onKeyDown={onKeyDown}
            InputProps={
              {
                classes,
                disableUnderline: true,
                autoComplete: 'none',
                disabled: disabled,
              } as Partial<OutlinedInputProps>
            }
            InputLabelProps={{ classes: { root: labelClasses.label, focused: labelClasses.label } }}
          />
        )}
      </InputMask>
    </Box>
  );
};
